import { render, staticRenderFns } from "./price-detail.vue?vue&type=template&id=6e1140f5&lang=pug&"
import script from "./price-detail.vue?vue&type=script&lang=js&"
export * from "./price-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports